export const statusPillStyles = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0.2rem 0.75rem',
    borderRadius: '999px',
    fontSize: '0.75rem',
    fontWeight: 600,
    border: '1px solid transparent',
    textTransform: 'capitalize',
    letterSpacing: 0.1,
  },
  variants: {
    default: { backgroundColor: '#e2e8f0', color: '#1f2937', borderColor: '#cbd5f5' },
    open: { backgroundColor: '#fff4e6', color: '#c2410c', borderColor: '#fed7aa' },
    closed: { backgroundColor: '#d1fae5', color: '#065f46', borderColor: '#a7f3d0' },
  },
  custom: {
    Incomplete: { backgroundColor: '#fef3c7', color: '#92400e', borderColor: '#fde68a' },
    Open: { backgroundColor: '#fff4e6', color: '#c2410c', borderColor: '#fed7aa' },
    Investigating: { backgroundColor: '#e0f2fe', color: '#075985', borderColor: '#bae6fd' },
    Resolved: { backgroundColor: '#dcfce7', color: '#166534', borderColor: '#bbf7d0' },
    RepairApproved: { backgroundColor: '#ede9fe', color: '#5b21b6', borderColor: '#ddd6fe' },
    FinalApproval: { backgroundColor: '#e0e7ff', color: '#3730a3', borderColor: '#c7d2fe' },
    RepairDenied: { backgroundColor: '#fee2e2', color: '#991b1b', borderColor: '#fecaca' },
    Completed: { backgroundColor: '#cffafe', color: '#0f172a', borderColor: '#a5f3fc' },
    Closed: { backgroundColor: '#d1fae5', color: '#065f46', borderColor: '#a7f3d0' },
  },
};

export const getStatusVariant = (statusKey) => {
  const openStatuses = ['Incomplete', 'Open', 'Investigating'];
  const closedStatuses = [
    'RepairApproved',
    'FinalApproval',
    'Resolved',
    'RepairDenied',
    'Completed',
    'Closed',
  ];
  if (openStatuses.includes(statusKey)) return 'open';
  if (closedStatuses.includes(statusKey)) return 'closed';
  return 'default';
};
